'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _GlobalApi = require('@/libs/GlobalApi');

var _GlobalApi2 = _interopRequireDefault(_GlobalApi);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _StateBrowser = require('@/components/StateBrowser.vue');

var _StateBrowser2 = _interopRequireDefault(_StateBrowser);

var _StateBrowserNetwork = require('@/customized-core/StateBrowserNetwork.vue');

var _StateBrowserNetwork2 = _interopRequireDefault(_StateBrowserNetwork);

var _Ad = require('@/customized-core/Ad.vue');

var _Ad2 = _interopRequireDefault(_Ad);

var _UserProfile = require('@/customized-core/UserProfile.vue');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    mixins: [_StateBrowser2.default],
    components: {
        StateBrowserNetwork: _StateBrowserNetwork2.default,
        Ad: _Ad2.default
    },
    props: {
        buffer: {
            type: Object,
            required: true
        }
    },
    data: function data() {
        return {
            isProfileMenuOpen: false,
            isAndroidKeyboardOpened: false,
            isAdsBlockHidden: false,
            timeout: null,
            needShift: false,
            shiftValue: null
        };
    },

    watch: {
        isAndroidKeyboardOpened: function isAndroidKeyboardOpened() {
            if (this.isAndroidKeyboardOpened) {
                this.isAdsBlockHidden = true;
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = null;
                }
            } else {
                var self = this;
                this.timeout = setTimeout(function () {
                    self.isAdsBlockHidden = self.isAndroidKeyboardOpened;
                }, 1000);
            }
        }
    },
    computed: {
        networkName: function networkName() {
            var name = TextFormatting.t('no_network');
            var network = this.getNetwork;
            if (network) {
                name = network.name;
            }
            return name;
        },
        nickname: function nickname() {
            var network = this.getNetwork;
            this.$forceUpdate();
            return network.nick;
        },
        unreadMessages: function unreadMessages() {
            var count = 0;
            var highlight = false;
            _state2.default.networks.forEach(function (network) {
                network.buffers.forEach(function (buffer) {
                    count += buffer.flags.unread || 0;
                    if (buffer.flags.highlight) {
                        highlight = true;
                    }
                });
            });
            return { count: count, highlight: highlight };
        },
        isMobile: function isMobile() {
            return _state2.default.isMobile;
        },
        adSize: function adSize() {
            return _state2.default.isMobile && !_state2.default.isTablet ? [300, 50] : [300, 250];
        },
        style: function style() {
            return {
                top: this.needShift ? this.shiftValue + 'px' : '0'
            };
        }
    },
    methods: {
        toggleProfile: function toggleProfile() {
            if (this.sidebarState.isDrawn) {
                this.sidebarState.close();
                if (this.sidebarState.activeComponent === _UserProfile2.default) {
                    this.hideStatebrowser();
                    this.sidebarState.activeComponent = null;
                    return;
                }
            }

            this.hideStatebrowser();

            _GlobalApi2.default.singleton().showInSidebar(_UserProfile2.default);
            this.sidebarState.sidebarOpen = true;
        },
        closeCurrentBuffer: function closeCurrentBuffer() {
            _state2.default.removeBuffer(this.buffer);
        },
        toggleStateBrowser: function toggleStateBrowser() {
            _state2.default.$emit('statebrowser.toggle');
        },
        privateAddFocusHandler: function privateAddFocusHandler(x) {
            var delta = window.visualViewport.height - x;
            this.shiftValue = delta < 250 ? -250 : 0;
            this.childHasFocus(true);
        },
        childHasFocus: function childHasFocus(status) {
            this.needShift = status;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/StateBrowser.vue
// module id = hiMT
// module chunks = 1